import { render, staticRenderFns } from "./BulkReviewModal.vue?vue&type=template&id=5420b790"
import script from "./BulkReviewModal.vue?vue&type=script&lang=js"
export * from "./BulkReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports